import { Component, inject, input } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatAutocomplete, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateAufgabeFormService } from '@schir-int-client/aufgabe';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';

type AllowedAufgabenTyp = AufgabenTyp.HEIMATHAFENVERLEGUNG | AufgabenTyp.HEIMATORTVERLEGUNG;

@Component({
	selector: 'schir-int-client-aufgabe-heimatverlegung-editor',
	imports: [
		MatCheckbox,
		MatAutocomplete,
		MatOption,
		MatFormField,
		MatLabel,
		MatInput,
		MatAutocompleteTrigger,
		FormsModule,
		ReactiveFormsModule,
	],
	templateUrl: './aufgabe-heimatverlegung-editor.component.html',
	styleUrl: './aufgabe-heimatverlegung-editor.component.scss',
})
export class AufgabeHeimatverlegungEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	public aufgabenTyp = input.required<AllowedAufgabenTyp>();

	protected readonly amtsgerichtOptions = [];

	protected get formGroup() {
		return this.formService.form.controls[this.aufgabenTyp()];
	}

	protected get bodyControls() {
		return this.formGroup.controls.body.controls;
	}

	protected toggleGerichtControl(enabled: boolean) {
		enabled ? this.bodyControls.gericht.enable() : this.bodyControls.gericht.disable();
	}
}
